module.exports = __webpack_public_path__ + "assets/img/img183.2fc38a38.png";